module.exports = __webpack_public_path__ + "static/img/lct1.d8fac75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lct1.png
// module id = SVTm
// module chunks = 1